import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { ITrendDataResultsModel } from "../../services/trending-data-service/Models";
import TrendingDataService from "../../services/trending-data-service/TrendingDataServices";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectGraphFileStoreDataQueryParameters = {
    contextGroupID: number;
    fileStoreID: number;
} & BaseUseQueryParameters<ITrendDataResultsModel>;

export function useObjectGraphFileStoreData(params: UseObjectGraphFileStoreDataQueryParameters) {
    return useQuery<ITrendDataResultsModel | undefined, RestError>(

        keys.fileStoreData(
            params.contextGroupID,
            params.fileStoreID),
        ({ signal }) => {
            return TrendingDataService.getFileStoreData(
                params.contextGroupID,
                params.fileStoreID,
                signal
            );
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            //refetchOnWindowFocus: params.refetchOnWindowFocus,
            staleTime: 0
        }
    );
}
